/* eslint-disable import/no-cycle */
import { fetchLeaderboardData } from "apis/leaderboard";
import { put, takeEvery } from "redux-saga/effects";
import { leaderboardAction } from "redux/slice/leaderboard";
import { enqueueSnackbar } from "notistack";

export function* getLeaderboardDataRequestSaga(action) {
  try {
    const info = yield fetchLeaderboardData(action.payload);

    if (info?.data?.success) {
      const { data } = info.data;

      yield put(leaderboardAction.getLeaderboardDataSuccess(data));
    } else {
      yield put(
        leaderboardAction.getLeaderboardDataFailed({
          errorMessage:
            info?.response?.status === 403
              ? ""
              : info?.response?.data?.message || "Something went wrong",
        })
      );
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(leaderboardAction.getLeaderboardDataFailed());
  }
}

export function* watchLeaderboardAsync() {
  yield takeEvery(leaderboardAction.getLeaderboardDataRequest, getLeaderboardDataRequestSaga);
}
